import { DetalleRegimenLaboralHEDTO, RegimenLaboralHEDTO } from "components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE"

export type MesesPlanificacionHEDTO = {
    numeroMes: number,
    nombreMes: string,
    puedeRealizarAccion?: boolean
}

export type DetallePlanificacionUnidadesHE = {
    listadoRegimenLaboralesPlan: DetalleRegimenLaboralHEDTO[]
    unidadesPlanificacion: UnidadesPlanificacionHEDTO[],
    listadoRegimenLaborales: RegimenLaboralHEDTO[],
    planificacionTotal: PlanificacionTotal
}

export const ESTADO_REVERSADO_TH = "RT"
export const ESTADO_REVERSADO = "RT"
export const ESTADO_SOLICITADO_REVERSO_A_TH = "SR"
export const ESTADO_ENVIADO_A_TH = "ET"

export type UnidadesPlanificacionHEDTO = {
    idEstructuraOrganica: number,
    nombreEstructura: string,
    articuloEstructura:string,
    idPlanificacionUnidad: number | null,
    detallePlanificacionRegimen: DetallePlanificacionUnidadRegimenHE[]
    detalleSolicitudReverso: DetalleSolicitudReverso
    presupuestoPlanificado: number | null
    presupuestoEjecutado: number | null
    presupuestoAsignado: number | null
    estado: string
    estadoString: string
}


export type DetallePlanificacionUnidadRegimenHE =
{
    idRegimenLaboral: number
    numPlanifPersona: number
    horasSuplementarias: number | null
    horasExtraordinarias : number | null
    totalHoras : number | null
    valorPlanificacionHSupl : number | null
    valorPlanificacionHExtr : number | null
    valorTotalPlanificacion : number | null
}


export type DetalleSolicitudReverso =
{
    idSolicitudReverso : number
    motivoReverso : string
    estado : string
    estadoString : string
    fechaSolicitud : string
}


export type PlanificacionTotal =
{
    valorTotalizadoRegimen: PlanificacionRegimenTotalUnidad[]
    valorTotalPlanificacion: number | null
}

export type PlanificacionRegimenTotalUnidad = 
{
    idRegimenLaboral: number,
    nroServidores: number | null,
    horaSuplementarias: number | null,
    horaExtraordinarias: number | null
    valorHoraTotal: number | null
}

export type ReversarUnidadPlanificacion = 
{
    planificacionUnidad: UnidadesPlanificacionHEDTO,
    motivo: string,
}

export type ReversarUnidadPlanificaciones = 
{
    planificacionUnidades: UnidadesPlanificacionHEDTO[],
    motivo: string,
}


